export enum ButtonTypeAttributeEnum{
    button,
    submit,
    reset
}